import { render, staticRenderFns } from "./CampaignsTableFilters.vue?vue&type=template&id=794864aa"
import script from "./CampaignsTableFilters.vue?vue&type=script&lang=js"
export * from "./CampaignsTableFilters.vue?vue&type=script&lang=js"
import style0 from "./CampaignsTableFilters.vue?vue&type=style&index=0&id=794864aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports